module.exports = __webpack_public_path__ + "static/media/Electrificacion motriz mineria cobre.8bb3b661.jpg";